import { CodeSystem } from "@intocare/datatypes/lib/code-system";

export const OBSERVATION_CORRECTIVE_ACTION = {
	name: "OBSERVATION_CORRECTIVE_ACTION",
	concept: {
		REST: {
			display: {
				"nl-BE": "Bedrust",
				"fr-BE": "Repos au lit",
			},
		},
		TRENDELENBURG: {
			display: {
				"nl-BE": "Bed in trendelenburg",
				"fr-BE": "Lit en position de Trendelenburg",
			},
		},
		DOCTOR_CONTACTED: {
			display: {
				"nl-BE": "Dokter verwittigd",
				"fr-BE": "Médecin contacté",
			},
		},
		FAMILY_CONTACTED: {
			display: {
				"nl-BE": "Familie verwittigd",
				"fr-BE": "Famille contactée",
			},
		},
		ICE: {
			display: {
				"nl-BE": "IJs",
				"fr-BE": "Glace",
			},
		},
		PAIN_MEDICATION: {
			display: {
				"nl-BE": "Pijnmedicatie",
				"fr-BE": "Médicament contre la douleur",
			},
		},
		WOUNDCARE: {
			display: {
				"nl-BE": "Wondverzorging",
				"fr-BE": "Soins des plaies",
			},
		},
		HOSPITAL: {
			display: {
				"nl-BE": "Ziekenhuisopname",
				"fr-BE": "Hospitalisation",
			},
		},
		LEGACY_FEET_IN_HIGH_POSITION: {
			display: {
				"nl-BE": "Voeten in hoogstand",
				"fr-BE": "Pieds en position haute",
			},
		},
		LEGACY_OINTMENT: {
			display: {
				"nl-BE": "Zalf",
				"fr-BE": "Pommade",
			},
		},
		LEGACY_SUPPORT: {
			display: {
				"nl-BE": "Steun/drukverband",
				"fr-BE": "Compresse/Bande de maintien",
			},
		},
		LEGACY_TAKE_BLOOD_PRESSURE: {
			display: {
				"nl-BE": "Bloeddruk nemen",
				"fr-BE": "Prise de la tension artérielle",
			},
		},
		LEGACY_OTHER: {
			display: {
				"nl-BE": "Andere",
				"fr-BE": "Autre",
			},
		},
	},
} as const satisfies CodeSystem;
